import { DEFAULT_END, DEFAULT_START, generateNextSlot } from "../../../../utils/timeUtils";
import { useState, useCallback, memo } from "react";
import Icons from "../../../../assets/js/Icons";
import { Button, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import SlotRow from "./slotRow";

const DayRow = memo(({ setValidationError }) => {
  const { data } = useSelector((state) => state.otherSlice);

  const [slots, setSlots] = useState([
    ...(
      data?.slots?.length ?
        data.slots :
        [{ _id: Date.now(), start: DEFAULT_START, end: DEFAULT_END }]
    ),
  ]);

  // const handleAddSlot = useCallback(() => {
  //   setSlots((prev) => {
  //     const lastSlot = prev[prev.length - 1];

  //     const next = generateNextSlot(lastSlot?.end || "09:00");

  //     if (!next) {
  //       return prev;
  //     }

  //     return [
  //       ...prev,
  //       {
  //         _id: Date.now(),
  //         ...next,
  //       },
  //     ];
  //   });
  // }, []);

  const handleAddSlot = useCallback(() => {
  setSlots((prev) => {
    const lastSlot = prev[prev.length - 1];

    const next = generateNextSlot(lastSlot?.end || "09:00");

    // ❗ IMPORTANT FIX
    if (!next) {
      setValidationError(
        "Slots cannot extend into the next day. Please adjust your previous slot end time to continue adding more slots."
      );
      return prev;
    }

    return [
      ...prev,
      {
        _id: Date.now(),
        ...next,
      },
    ];
  });
}, [setValidationError]);

  const handleDelete = useCallback(async (id) => {
    setSlots((prev) => prev.filter((s) => s._id !== id));
    // eslint-disable-next-line
  }, []);

  const handleSlotChange = useCallback((id, field, value) => {
    setSlots((prev) =>
      prev.map((s) =>
        s._id === id ? { ...s, [field]: value } : s
      )
    );
  }, []);

  return (
    <>
      <Stack spacing={2}>
        <Button
          size="small"
          variant="contained"
          onClick={handleAddSlot}
          sx={{ alignSelf: "end" }}
          startIcon={<Icons.PlusSolid />}
        >Add slot
        </Button>
        {slots.map((slot, i) => (
          <SlotRow
            index={i}
            key={slot._id}
            slot={slot}
            onChange={(field, value) =>
              handleSlotChange(slot._id, field, value)
            }
            onDelete={() => handleDelete(slot._id)}
          />
        ))
        }
      </Stack>
    </>
  );
});

export default DayRow;